import { NavLink } from 'react-router-dom'
import {
  LayoutGrid, Bot, Wrench, BookOpen, Server, Users2,
  ClipboardList, CalendarClock, ShieldCheck,
} from 'lucide-react'

const linkStyle = ({ isActive }: { isActive: boolean }): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '8px 12px',
  borderRadius: 'var(--radius-sm)',
  fontSize: 14,
  color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
  background: isActive ? 'var(--surface-raised)' : 'transparent',
})

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div
        style={{
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: 'var(--text-tertiary)',
          padding: '0 12px',
          marginBottom: 6,
        }}
      >
        {title}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>{children}</div>
    </div>
  )
}

export function Sidebar() {
  return (
    <nav
      style={{
        width: 220,
        flexShrink: 0,
        borderRight: '1px solid var(--border)',
        padding: '20px 12px',
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <div style={{ padding: '0 12px', marginBottom: 24 }}>
        <div style={{ fontSize: 14, fontWeight: 500 }}>IT AI Agents</div>
        <div style={{ fontSize: 11, color: 'var(--text-tertiary)' }}>Connect</div>
      </div>

      <Section title="General">
        <NavLink to="/" end style={linkStyle}>
          <LayoutGrid size={16} /> Overview
        </NavLink>
        <NavLink to="/agents" style={linkStyle}>
          <Bot size={16} /> Agentes
        </NavLink>
      </Section>

      <Section title="Catálogo">
        <NavLink to="/tools" style={linkStyle}>
          <Wrench size={16} /> Tools
        </NavLink>
        <NavLink to="/skills" style={linkStyle}>
          <BookOpen size={16} /> Skills
        </NavLink>
        <NavLink to="/platforms" style={linkStyle}>
          <Server size={16} /> Plataformas
        </NavLink>
      </Section>

      <Section title="Equipos">
        <NavLink to="/teams/cx" style={linkStyle}>
          <Users2 size={16} /> CX
        </NavLink>
        <NavLink to="/teams/seo" style={linkStyle}>
          <Users2 size={16} /> SEO
        </NavLink>
      </Section>

      <Section title="Operación">
        <NavLink to="/job-board" style={linkStyle}>
          <ClipboardList size={16} /> Job Board
        </NavLink>
        <NavLink to="/schedules" style={linkStyle}>
          <CalendarClock size={16} /> Schedules
        </NavLink>
        <NavLink to="/admin/users" style={linkStyle}>
          <ShieldCheck size={16} /> Admin
        </NavLink>
      </Section>
    </nav>
  )
}
